import { DeleteOutlined } from "@ant-design/icons";
import { Badge, Button, Card, Col, Popover, Row, Typography } from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { deletePurchase } from "../../redux/actions/purchase/deletePurchaseAction";
import { loadSinglePurchase } from "../../redux/actions/purchase/detailPurchaseAction";
import CardComponent from "../Card/card.components";
import PurchaseProductListCard from "../Card/purchaseInvoice/PurchaseProductListCard";
import ReturnPurchaseInvoiceList from "../Card/purchaseInvoice/ReturnPurchaseInvoiceList";
import TransactionPurchaseList from "../Card/purchaseInvoice/TransactionPurchaseList";
import PurchaseInvoice from "../Invoice/PurchaseInvoice";
import Loader from "../loader/loader";
import "./purchase.css";

const DetailsPurch = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const purchase = useSelector((state) => state.purchases.purchase);
	const {
		status,
		totalPaidAmount,
		totalReturnAmount,
		dueAmount,
		singlePurchaseInvoice,
		returnPurchaseInvoice,
		transactions,
	} = purchase ? purchase : {};

	const onDelete = async () => {
		try {
			const result = await dispatch(deletePurchase(id));
			setVisible(false);
			if (result?.message === "success") {
				navigate("/purchaselist");
			}
		} catch (error) {
			console.log(error.message);
		}
	};

	const [visible, setVisible] = useState(false);
	const handleVisibleChange = (newVisible) => setVisible(newVisible);

	useEffect(() => {
		dispatch(loadSinglePurchase(id));
	}, [id]);

	const isLogged = Boolean(localStorage.getItem("isLogged"));
	if (!isLogged) {
		return <Navigate to="/auth/login" replace />;
	}

	const invoiceRef = singlePurchaseInvoice?.prefix && (singlePurchaseInvoice?.invoice_number != null)
		? `${singlePurchaseInvoice.prefix}${singlePurchaseInvoice.invoice_number}`
		: singlePurchaseInvoice?.prefix
		? `${singlePurchaseInvoice.prefix}${singlePurchaseInvoice.id}`
		: singlePurchaseInvoice
		? `PINV/25-26/${singlePurchaseInvoice.invoice_number ?? singlePurchaseInvoice.id}`
		: "";

	return (
		<div className="purchase-detail-page">
			<div className="purchase-detail-wrap">
				{singlePurchaseInvoice ? (
					<Fragment key={singlePurchaseInvoice.id}>
						<Card bordered={false} className="purchase-detail-card">
							<div className="purchase-detail-header">
								<h5 className="purchase-detail-title">
									<i className="bi bi-receipt" aria-hidden />
									<span className="purchase-detail-name">
										Purchase Invoice {invoiceRef}
									</span>
								</h5>
								<div className="purchase-detail-actions">
									<Link to={`/purchase/return/${id}`}>
										<Button type="primary" shape="round">
											Return Product
										</Button>
									</Link>
									<Popover
										content={
											<a onClick={onDelete}>
												<Button type="primary" danger>Yes Please !</Button>
											</a>
										}
										title="Are you sure you want to delete ?"
										trigger="click"
										visible={visible}
										onVisibleChange={handleVisibleChange}>
										<Button type="danger" shape="round" icon={<DeleteOutlined />} aria-label="Delete" />
									</Popover>
									<PurchaseInvoice data={singlePurchaseInvoice} />
								</div>
							</div>
							<div className="purchase-detail-body">
								<Row gutter={[16, 16]} justify="space-around">
									<Col xs={24} md={11}>
										<CardComponent title="Initial invoice information">
											<p>
												<Typography.Text strong>Purchase Date :</Typography.Text>{" "}
												<strong>{moment(singlePurchaseInvoice.date).format("ll")}</strong>
											</p>
											<p>
												<Typography.Text strong>Supplier :</Typography.Text>{" "}
												<Link to={`/supplier/${singlePurchaseInvoice.supplier.id}`}>
													<strong>{singlePurchaseInvoice.supplier.name}</strong>
												</Link>
											</p>
											<p>
												<Typography.Text strong>Total Amount :</Typography.Text>{" "}
												<strong>{singlePurchaseInvoice.total_amount}</strong>
											</p>
											<p>
												<Typography.Text strong>Discount :</Typography.Text>{" "}
												<strong>{singlePurchaseInvoice.discount}</strong>
											</p>
											<p>
												<Typography.Text strong>Paid Amount :</Typography.Text>{" "}
												<strong>{singlePurchaseInvoice.paid_amount}</strong>
											</p>
											<p>
												<Typography.Text strong>Due Amount :</Typography.Text>{" "}
												<strong className="text-danger">{singlePurchaseInvoice.due_amount}</strong>
											</p>
										</CardComponent>
									</Col>
									<Col xs={24} md={12}>
										<Badge.Ribbon
											text={status}
											color={status === "PAID" ? "green" : status === "PARTIAL PAID" ? "orange" : "red"}>
											<CardComponent title="New Invoice Information">
												<p>
													<Typography.Text strong>Total Paid Amount :</Typography.Text>{" "}
													<strong>{totalPaidAmount}</strong>
												</p>
												<p>
													<Typography.Text strong>Total Return Amount :</Typography.Text>{" "}
													<strong>{totalReturnAmount}</strong>
												</p>
												<p>
													<Typography.Text strong>Due Amount :</Typography.Text>{" "}
													<strong style={{ color: "red" }}>{dueAmount}</strong>
												</p>
											</CardComponent>
										</Badge.Ribbon>
										<div className="mt-2">
											<CardComponent>
												<p>
													<Typography.Text strong>Supplier Memo No :</Typography.Text>{" "}
													<strong>{singlePurchaseInvoice.supplier_memo_no}</strong>
												</p>
												<p>
													<Typography.Text strong>Note :</Typography.Text>{" "}
													<strong>{singlePurchaseInvoice.note}</strong>
												</p>
											</CardComponent>
										</div>
									</Col>
								</Row>
								<PurchaseProductListCard list={singlePurchaseInvoice.purchaseInvoiceProduct} />
								<ReturnPurchaseInvoiceList list={returnPurchaseInvoice} supplier={singlePurchaseInvoice.supplier} />
								<TransactionPurchaseList list={transactions} />
							</div>
						</Card>
					</Fragment>
				) : (
					<Loader />
				)}
			</div>
		</div>
	);
};

export default DetailsPurch;
